import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar"

export function ContactRender({ contact }: { contact: Contact }) {

  return <div className="flex items-center justify-start">
    <Avatar className="mr-2">
      <AvatarImage src={contact?.avatar} alt={contact?.name || "?"} />
      <AvatarFallback>?</AvatarFallback>
    </Avatar>
    <div className="text-foreground text-sm truncate">
      {contact?.name || "?"}
    </div>
  </div>
}